export default "__VITE_ASSET__KNSin0L0__"